const LABELS: Record<string, string> = {
  APPROVED: 'Approved',
  CANCELLED: 'Canceled',
  CANCELED: 'Canceled',
  PENDING: 'Pending approval',
  SUBMITTED: 'Submitted',
  REJECTED: 'Rejected',
  WITHDRAWN: 'Withdrawn',
  DRAFT: 'Draft',
};

const CATEGORIES: Record<
  string,
  'neutral' | 'success' | 'warning' | 'danger' | 'info'
> = {
  APPROVED: 'success',
  CANCELLED: 'neutral',
  CANCELED: 'neutral',
  PENDING: 'warning',
  SUBMITTED: 'info',
  REJECTED: 'danger',
  WITHDRAWN: 'neutral',
  DRAFT: 'neutral',
};

export function getAttendanceCorrectionStatusLabel(
  status: string | null | undefined,
): string {
  if (!status) return 'Status unavailable';
  return LABELS[status] ?? 'Status unavailable';
}

export function getAttendanceCorrectionStatusCategory(
  status: string | null | undefined,
): 'neutral' | 'success' | 'warning' | 'danger' | 'info' {
  if (!status) return 'neutral';
  return CATEGORIES[status] ?? 'neutral';
}
